export default __webpack_public_path__ + "static/media/bg-old-man.0cade858.jpg";